function getToken(key) {
    var b = document.cookie.match("(^|;)\\s*" + key + "\\s*=\\s*([^;]+)");
    return b ? b.pop() : false;
}

function setCookie(key){
    document.cookie = `jodiactoken=${key}; expires=Thu, 18 Dec 2030 12:00:00 UTC; path=/` ;
    return 200;
}

function deleteToken(key) {
    document.cookie = `jodiactoken=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
    return 200;
}

export {getToken,setCookie,deleteToken}